import React from 'react';
import CustomModal, { CustomModalContent, CustomModalFooter, ModalPrimaryButton } from '../..';
import "./styles.css";
import { useRoute, useBCMSModal } from "@bcm-dev/bcms-vite";
/**
 * @function UpdatedCardOnFileModal
 * @return {React.Component}
 * @exported true
 * @description The modal for updating card on file 
 */

export default function UpdatedCardOnFileModal(props){
  const navigate = useRoute();
  const { close } = useBCMSModal();

  const onOKClick = evt => {
    close("UpdatedCardOnFileModal");

    if(props.data) {
      if(props.data.onOKClick) {
        props.data.onOKClick();
      } else {
        navigate("/home/cardonfile/cardonfile")
      }
    }
  }

  return(
    <CustomModal className="updated-card-on-file-modal" id="UpdatedCardOnFileModal">
        <CustomModalContent>
            <p className="text-center">Your Card on File list has been updated. The list is maintained
            for your information purpose only. Contact the merchant or service provider if you want to
            update or remove your card information on their file.</p>
        </CustomModalContent>
        <CustomModalFooter className="button-container">
            <ModalPrimaryButton text="OK" onClick={ onOKClick } />
        </CustomModalFooter>
    </CustomModal>
  );
}